import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import SelectField from "../../Shared/SelectField";
import {years_list, months_list} from "../../Shared/List";

import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { FaFileExport } from "react-icons/fa"

const ZeroReadingSummary = () => {
    const [errors, setErrors] = useState({})
    const [billed, setBilled] = useState([])
    const [title, setTitle] = useState('')
    const [yearOptions, setYearOptions] = useState([])
    const [monthOptions, setMonthOptions] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const current_user = JSON.parse(localStorage.getItem('user'))
    const billing_date  = current_user?.branch?.billing_date

    const gridRef = useRef();
    const navigate = useNavigate()
    const location = useLocation()

    const [formData, setFormData] = useState({
        year: location.state?.year || billing_date?.year,
        month: location.state?.month || billing_date?.month,
    })
    const {year, month} = formData

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
                if (isNaN(params.node.id)) {
                    return "";
                }
                return `${Number(params.node.rowIndex) + 1}`;
            },
        },
        {
            headerName: "Name",
            field: "full_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Locations",
            field: "locations",
            sortable: true,
            filter: 'agNumberColumnFilter',
            valueFormatter: params => Number(params.value),
            comparator: (valueA, valueB) => valueA - valueB
        },
    ], [])

    const getBilled = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.get(`/billed/zero-reading-summary?year=${payload.year}&month=${payload.month}`)
            const years = []
            const months = []

            years_list.map(year => (
                years.push({
                    id: year.id,
                    key: year.key,
                    name: year.name
                })
            ))

            months_list.map(month => (
                months.push({
                    id: month.id,
                    key: month.key,
                    name: month.name
                })
            ))

            setBilled(response?.data)
            setYearOptions(years)
            setMonthOptions(months)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error?.response?.status === 403){
                toast.error(error?.response?.data?.detail || 'Forbidden');
                navigate('/');
            }else {
                toast.warning(error?.response?.data?.detail || 'Failed to load zero reading summary')
            }
        }
    }

    useEffect(() => {

        setTitle(`${months_list[month - 1].name}-${year}, Zero Reading Location by Collector`)
        getBilled({year, month})
    }, [])

    const onDoubleClick = (payload) => {
        navigate(`/zero-reading-detail`, { state: {payload: payload}})
    }

    let gridApi

    const onGridReady=(params)=>{
        gridApi=params.api
    }
      const onExportClick=()=>{
        gridApi.exportDataAsCsv({ fileName: `${title}.csv` })
    }

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))

    }

    const onSubmit = (e) => {
        e.preventDefault()

        setTitle(`${months_list[month - 1].name}-${year}, Zero Reading Customers`)
        const payload = {year, month}
        getBilled(payload)
    }

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-2">
                    <SelectField
                        name="year"
                        value={parseInt(year)}
                        options={yearOptions}
                        onChange={onChange}
                        error={errors.year}
                    />
                </div>
                <div className="col-md-2">
                    <SelectField
                        name="month"
                        value={parseInt(month)}
                        options={monthOptions}
                        onChange={onChange}
                        error={errors.month}
                    />
                </div>
                <div className="col-md-6">
                    <input type="submit" className="btn btn-info mt-1" value="Apply Filter" style={{float: 'left'}}/>
                </div>
                <div className="col-md-2">
                    <button onClick={()=>onExportClick()} className="btn btn-success" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card mt-0">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                    <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            onRowDoubleClicked={(e) =>{
                                if (e.node.rowPinned) return '';
                                if (e.data.locations < 1) return '';
                                onDoubleClick({
                                    year: parseInt(year),
                                    month: parseInt(month),
                                    collector_id: e.data.id,
                                    collector_name: e.data.full_name
                                })
                            }}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}
                            suppressMenuHide={true}
                            rowData={billed}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}

                            pagination={false}
                            onGridReady={onGridReady}

                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}


                            ref={gridRef}
                            groupIncludeTotalFooter={false}
                            groupIncludeFooter={false}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
            </div>
        </div>
      <br/>
    </>
  )
}

export default ZeroReadingSummary
